export const homeNav = [
  { id: "doctor",  name: '找医生', offset: -160 },
  { id: "healthAnswer",  name: '患友问诊', offset: -80 },
  { id: "article",  name: '科普文章', offset: -80 },
]